import { CodeListComponent } from './code-list.component';

/**
 * コード情報リストモデルクラス
 *
 * @export CodeListModel
 * @class CodeListModel
 */
export class CodeListModel {

  /**
   * コード情報リスト
   */
  public list: any[];

  // リストインスタンス
  public codeList: CodeListComponent;

  /**
   * コード情報を更新する
   *
   * @param serverData コード情報のサーバ取得データ
   */
  public updateCodeList(serverData: any[]): void {
    // NULLチェック
    if (serverData == null) {
      this.list = [];
      return;
    }

    const tempCodeList = serverData;

    let index: number = <number>0;

    // コード+：+名称を設定
    for (; index < tempCodeList.length; index++) {
      tempCodeList[index].CodeValueName = tempCodeList[index].CodeValue + ':' + tempCodeList[index].CodeName;
    }

    this.list = tempCodeList;

    // コードリスト情報更新完了処理
    this.codeList.updateListComplete();
  }

}
